import type { HolisticSummaryCategory } from '@fruitful/types';
import { useLocalSearchParams } from 'expo-router';

import Transactions from '../../../../../holistic/components/transaction/Transactions';

export default function HolisticAccountTransactions() {
    const { category } = useLocalSearchParams<{
        category: HolisticSummaryCategory;
    }>();
    const { id } = useLocalSearchParams<{ id: string }>();
    const { connectionId } = useLocalSearchParams<{ connectionId: string }>();

    return (
        <Transactions category={category} id={id} connectionId={connectionId} />
    );
}
